import {Component, OnInit, ViewChild, ElementRef, Renderer2, OnDestroy} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {BetslipComponent} from '../betslip/betslip.component';
import {ActivatedRoute} from "@angular/router";
import {MatchService} from "../services/match.service";
import {Router} from "@angular/router";

import {Subscription, switchMap} from "rxjs";
import {SessionBetsService} from "../services/session-bets.service";
import {SessionLadder} from "../modals/session-ladder/session-ladder.component";
import {BookmakerService} from "../services/bookmaker.service";
import {BookmakerBetsService} from "../services/bookmaker-bets.service";
import {ExposureService} from "../services/exposure.service";
import {ToastrService} from "ngx-toastr";
import {MarketBetsService} from "../services/market-bets.service";
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {FancyBetsService} from "../services/fancy-bets.service";
import {HttpClient} from '@angular/common/http';
import {SafeHtml} from '@angular/platform-browser';
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {BetSlipService} from "../services/betslip.service";
import { BetListModelComponent } from '../modals/bet-list/list.component';
import {TennisoddsService} from "../services/tennis/tennisodds.service";
import {BannerService} from "../services/banner.service";
import {environment} from "../../environments/environment";
import {SocceroddsService} from "../services/soccer/soccerodds.service";
import {NgbCarouselConfig} from "@ng-bootstrap/ng-bootstrap";
import {LiveCasinoService} from "../services/livecasino.service";
import {UserService} from "../services/user.service";

@Component({
    selector: 'app-matchdetail',
    templateUrl: './matchdetail.component.html',
    styleUrls: ['./matchdetail.component.css'],
    // encapsulation: ViewEncapsulation.None

})
export class MatchdetailComponent implements OnInit, OnDestroy {
    htmlContent: SafeHtml;
    @ViewChild('btn') btn: ElementRef;
    data: any = {
        type: "back",
        value: 12
    };

    videourl: any = "";
    scoreurl: any = "";
    show_tv:boolean = false;
    inplay:any = false;

    event: any = [];
    event_id: any;
    market: any = [];
    markets: any = [];
    book_maker_odd: any = [];
    book_maker_odds: any = [];

    sessions: any = [];
    meters:any = [];
    ballbyball:any = [];
    overbyovers:any = [];
    fancies: any = [];
    session_bets: any[] = [];
    fancy_bets: any[] = [];
    match_bets: any[] = [];
    bookmaker_bets: any[] = [];
    score: any = {};
    scoreLength = 0;
    myInterval: any
    exposuresPerRunner: any = [];
    fancyExposuresPerRunner: any = [];
    is_score: boolean = false;
    market_name: any;
    competition_name: any;
    marketStartTime: any;
    math = Math
    last24ballsNew: any = [];

    cashout_submited: boolean = false;
    cashout_price: any;
    show_cashout_confirm: boolean = false;
    cashout_errmsg = "";

    selectedTabIndex = 0;
    enable_draw: boolean = false;
    private sessionSubscription: Subscription;
    private fancySubscription: Subscription;
    private scoreSubscription: Subscription;
    private marketSubscription: Subscription;
    private bookmakerSubscription: Subscription;

    cash_out_profit = 0;
    total_profit_loss = 0;
    status = '';
    isMobile: boolean;
    total_bets:number=0;

 user_id = localStorage.getItem("user_id");
    username = localStorage.getItem("username");
    balance = 0;
    vendors: any = [];
    allCategories: any = [];
    categories: any = [];
    gameList: any = [];
  all_bets: any[] = [];
    filtered_gameList: any = [];
    gameurl: any = "";
    activeVendor: string = "";
    activeCategory: string = "";
    searchKeyword: string = "";
    isloading: boolean = true;
    is_active: boolean = true;
    clicked = false;
    selectedGame: string = "";
    exposure: any = [];
    currentPage: number = 1;
    totalPages: number = 1;
    private typingTimer: any;
    private doneTypingInterval: number = 500;
    popular_games: any = [
        {
            "game_name": "Aviator",
            "casinoGameId": "aviator",
            "provider": "SPB",
            "description": "Spribe",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/Aviator_1697879631441.088.png"
        },
        {
            "game_name": "Auto-Roulette 1",
            "casinoGameId": "225",
            "provider": "PP",
            "description": "Pragmatic Play",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/Auto-Roulette_1662035764514.8215.jpg"
        },
        {
            "game_name": "6+ Poker",
            "casinoGameId": "BTV-6poker",
            "provider": "QT",
            "description": "Qtech",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/Poker-6_1722498432389.0283.png"
        },
        {
            "game_name": "1Tap Mines",
            "casinoGameId": "TRB-1tapmines",
            "provider": "QT",
            "description": "Qtech",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/1Tap-Mines_1721654154647.2036.png"
        },
        {
            "game_name": "1 Day Dragon Tiger",
            "casinoGameId": "150036",
            "provider": "DC",
            "description": "Dream Casino",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/1-Day-Dragon-Tiger_1725447005067.8533.png"
        },
        {
            "game_name": "Andar Bahar",
            "casinoGameId": "150007",
            "provider": "DC",
            "description": "Dream Casino",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/Andar-Bahar_1725445527067.6743.png"
        },
        {
            "game_name": "7 Up 7 Down",
            "casinoGameId": "400067",
            "provider": "DC",
            "description": "Dream Casino",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/7up7down_1694793541331.5251.png"
        },
        {
            "game_name": " Aladdin and the Sorcerer",
            "casinoGameId": "vs20aladdinsorc",
            "provider": "PP",
            "description": "Pragmatic Play",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/Aladdin-and-the-Sorcerer_1662559502173.5122.jpg"
        },
        {
            "game_name": "Pine of Plinko",
            "casinoGameId": "PRS-pineofplinko",
            "provider": "QT",
            "description": "Qtech",
            "logo_square":  "http://files.worldcasinoonline.com/Document/Game/Pine-of-Plinko_1724142014219.104.png"
        },
        {
            "game_name": "Monopoly Big Baller",
            "casinoGameId": "1000419",
            "provider": "EVZ",
            "description": "Evolution - Ezugi",
            "logo_square":  "http://files.worldcasinoonline.com/Document/Game/Monopoly Big Baller_1691069717539.7944.png"
        },
    ];
  isDesktop: boolean = true;

    constructor(public betSlipService: BetSlipService, private http: HttpClient, public sanitizer: DomSanitizer, public dialog: MatDialog, private toastr: ToastrService, private bookMakerService: BookmakerService, private BookmakerBetService: BookmakerBetsService, private renderer: Renderer2, private activatedRoute: ActivatedRoute, private matchService: MatchService, private sessionBetsService: SessionBetsService, private matchBetsService: MarketBetsService, private exposureService: ExposureService, private fancyBetService: FancyBetsService, private imageLightBoxService: NgbModal, private userService: UserService, private liveCasinoService: LiveCasinoService,private router: Router) {
    }


    ngOnInit(): void {
        this.getVendorList();

        this.checkIsMobile();
        window.addEventListener('resize', () => {
            this.checkIsMobile();
        });

        // this.fetchHTMLPage();
        this.activatedRoute.params.subscribe((param: any) => {
            console.log('innn match details')
            this.event_id = param['event_id'];
            // this.videourl = this.sanitizer.bypassSecurityTrustResourceUrl("https://nlivetv.lagaikhaipro.com/rtv.php?eventId=" + this.event_id);
            // this.videourl = this.sanitizer.bypassSecurityTrustResourceUrl("https://mis3.sqmr.xyz/rtv.php?eventId=" + this.event_id);
            this.videourl = this.sanitizer.bypassSecurityTrustResourceUrl("https://mis3.sqmr.xyz/rtv.php?eventId=" + this.event_id);
            this.scoreurl = this.sanitizer.bypassSecurityTrustResourceUrl("https://dpmatka.in/sr.php?eventid=" + this.event_id+"&sportid=4");
            //console.log(this.videourl);
        })
        this.getMarket();
        this.getBookMakerOdds();
        this.getSession();
        this.getFancy();
        this.getLiveScore();
        this.getBookmakerBets();
        

        this.myInterval = setInterval(() => {
            if (this.market.length > 0) {
                this.getMarket();
            }

            this.getSession();
            this.getBookMakerOdds();
            this.getFancy();
            if (this.bookmaker_bets.length > 0) {
                this.getBookmakerBets();
            }
            if (this.scoreLength > 0) {
                this.getLiveScore();
            }
            if (this.match_bets.length > 0) {
                this.getMatchBets();
            }
            if (this.session_bets.length > 0) {
                this.getSessionBets();
            }
            if (this.fancy_bets.length > 0) {
                this.getFancyBets();
            }
            this.getLiveScore();
           // this.total_bets = this.match_bets.length+this.bookmaker_bets.length+this.fancy_bets.length+this.session_bets.length;
            // this.calculateCashOut();
        }, 1000);

        this.matchBetsService.refreshMatchBets.subscribe(() => {
            this.getMatchBets();
        })
        this.getMatchBets();
        this.BookmakerBetService.refreshBookmakerBets.subscribe(() => {
            this.getBookmakerBets();
        })
        this.getBookmakerBets();

        this.fancyBetService.refreshFancyBets.subscribe(() => {
            this.getFancyBets();
        });
        this.getFancyBets();

        this.sessionBetsService.refresh.subscribe(() => {
            this.getSessionBets();
        })
        this.getSessionBets();

        this.exposureService.refreshExposureAmtByRunner.subscribe(() => {
            this.getExposureByRunnerName();
        });
        this.getExposureByRunnerName();

        this.exposureService.refreshFancyExposureAmtByRunner.subscribe(() => {
            this.getFancyExposureByRunnerName();
        })
        this.getFancyExposureByRunnerName();
        
    }

    getInterestingReverseLoop(data: any[], overNumber: any) {
        const stringWithoutParentheses = overNumber.replace(/[()]/g, '');
        const numberValue = parseFloat(stringWithoutParentheses);
        const startIndex = Math.floor(numberValue * 10) % 10;
        // console.log('index', Number(numberValue));
        const interestingLoopData = [];

        // Fill the array with zero values
        for (let i = 0; i < 6; i++) {
            interestingLoopData.push({
                score_card: "-",
                out_text: "0",
                comment: ""
            });
        }
        if (data.length > 0) {
            if (startIndex > 0) {
                const relevantData = data.slice(-startIndex);
                // console.log('RD-->', relevantData);


                for (let i = 0; i < relevantData.length && i < 6; i++) {
                    interestingLoopData[i].score_card = relevantData[i].score_card ? relevantData[i].score_card : '-';
                }
                // console.log('na-->', interestingLoopData);
            } else {
                for (let i = 0; i < 6; i++) {
                    interestingLoopData[i].score_card = data[i].score_card ? data[i].score_card : '-';
                }
            }
        }
        return interestingLoopData;
    }

    getMarket() {
        this.marketSubscription = this.matchService.getMarketOdd(this.event_id).subscribe((res: any) => {
                this.markets = res;
                if (this.markets.length > 0) {
                    this.market_name = this.markets[0].event_name;
                    this.competition_name = this.markets[0].competition_name;
                    this.marketStartTime = this.markets[0].start_time;
                    this.inplay = this.markets[0].inplay==1?true:false;
                    if (this.match_bets.length != 0) {
                        if (this.match_bets[0].length != 0) {
                            this.market = this.markets.map((obj1: any) => {
                                let match_bet = []
                                match_bet.push(this.match_bets[0]);
                                const obj2 = match_bet.find((obj2: any) => (obj2.event_id == obj1.event_id && obj2.status == 1));
                                if (obj2) {
                                    return {
                                        ...obj1,
                                        exp_amount1: obj2.exp_amount1,
                                        exp_amount2: obj2.exp_amount2,
                                        exp_amount3: obj2.exp_amount3
                                    };
                                } else {
                                    return {...obj1, exp_amount1: 0, exp_amount2: 0, exp_amount3: 0};
                                }
                            });
                        }
                    } else {
                        this.market = this.markets.map((obj: any) => ({
                            ...obj,
                            exp_amount1: 0,
                            exp_amount2: 0,
                            exp_amount3: 0
                        }));
                    }
                    if (this.market[0].hasOwnProperty('back2_price')) {
                        if (this.market[0].back2_price != null) {
                            this.enable_draw = true;
                        } else if (this.market[0].back2_price == null) {
                            this.enable_draw = false;
                        }
                    }
                }
            }
        )
        // console.log('this amrket', this.market);
    }

    getBookMakerOdds() {
        this.bookmakerSubscription = this.bookMakerService.getBookmakerOdd(this.event_id).subscribe((res: any) => {
            this.book_maker_odds = res;
            if (this.book_maker_odds.length > 0) {
                this.market_name = this.book_maker_odds[0].event_name;
                console.log('bookmaker length', this.bookmaker_bets.length);
                if (this.bookmaker_bets.length != 0) {
                    if (this.bookmaker_bets[0].length != 0) {
                        // console.log('in book');
                        this.book_maker_odd = this.book_maker_odds.map((obj1: any) => {
                            let bookmaker_bet = []
                            bookmaker_bet.push(this.bookmaker_bets[0]);
                            // console.log('bookmaker bet-->',bookmaker_bet);
                            const obj2 = bookmaker_bet.find((obj2: any) => (obj2.event_id == obj1.event_id && obj2.status == 1));
                            // console.log('obj2-->',obj2);
                            if (obj2) {
                                return {
                                    ...obj1,
                                    exp_amount1: obj2.exp_amount1,
                                    exp_amount2: obj2.exp_amount2,
                                    exp_amount3: obj2.exp_amount3,
                                    status: obj2.status
                                };
                            } else {
                                return {...obj1, exp_amount1: 0, exp_amount2: 0, exp_amount3: 0};
                            }
                        });
                    }
                } else {
                    this.book_maker_odd = this.book_maker_odds.map((obj: any) => ({
                        ...obj,
                        exp_amount1: 0,
                        exp_amount2: 0,
                        exp_amount3: 0
                    }));
                }
                if (this.book_maker_odd[0].hasOwnProperty('back2_price')) {
                    if (this.book_maker_odd[0].back2_price != null) {
                        this.enable_draw = true;
                    } else if (this.book_maker_odd[0].back2_price == null) {
                        this.enable_draw = false;
                    }
                }
            }
        })
        // console.log('book,=', this.book_maker_odd);

    }

    getBookmakerBets() {
        this.BookmakerBetService.getBookmakerBets(this.event_id).subscribe((data: any) => {
            this.bookmaker_bets = data;
        });
    }

    getSession() {
        this.sessionSubscription = this.matchService.getSession(this.event_id).subscribe((res: any) => {
            if (res != null) {
                this.sessions = res;
                this.sessions = this.sessions.sort((a: any, b: any) => a.sr_no - b.sr_no);
                if (this.exposuresPerRunner.length != 0) {
                    this.sessions = this.sessions.map((obj1: any) => {
                        const obj2 = this.exposuresPerRunner.find((obj2: any) => (obj2.runner_name === obj1.runner_name && obj2.status == 1));
                        // console.log(obj2);
                        return obj2 ? {...obj1, ...obj2} : {...obj1, exp_amount: 0};
                    });
                } else {
                    this.sessions = this.sessions.map((obj: any) => ({...obj, exp_amount: 0}));
                }

                 // Separate sessions and meters based on game_name
            this.meters = this.sessions.filter((obj: any) => obj.game_type === 'meter');
            this.sessions = this.sessions.filter((obj: any) => obj.game_type === 'session');
            this.ballbyball = [];
            this.overbyovers = [];
            // Filter out objects with runner_name containing 'ball runs'
            this.sessions = this.sessions.filter((item:any) => {
            // Check for "ball run" and add to ballbyball
                if (/.*ball run.*/.test(item.runner_name)) {
                    this.ballbyball.push(item);
                return false; // Exclude from originalArray
                }
                // Check for "Only over run", "6 over run", or "ball No Boundaries" and add to overByOvers
                if (/.*Only.*over run.*|.*ball No Boundaries.*/.test(item.runner_name)) {
                    this.overbyovers.push(item); // Add to overByOvers array
                    return false; // Exclude from sessions
                }
                return true; // Keep in originalArray
            });

            } else {
                this.sessions = [];
                this.ballbyball = [];
                this.overbyovers = [];
                this.meters = [];
            }
        });
        console.log('session-->', this.sessions);
        console.log('ballbyball-->', this.ballbyball);
        console.log('overbyovers-->', this.overbyovers);
        // console.log('meters-->', this.meters);
    }

    getFancy() {
        this.fancySubscription = this.matchService.getFancy(this.event_id).subscribe((res: any) => {
            if (res != null) {
                // res.sort((a:any, b:any) => a.srno.localeCompare(b.srno));
                this.fancies = res;
                this.fancies = this.fancies.sort((a: any, b: any) => a.sid - b.sid);
                if (this.fancyExposuresPerRunner.length != 0) {
                    this.fancies = this.fancies.map((obj1: any) => {
                        const obj2 = this.fancyExposuresPerRunner.find((obj2: any) => (obj2.runner_name === obj1.runner_name && obj2.status == 1));
                        // console.log('obj2-->',obj2);
                        return obj2 ? {...obj1, ...obj2} : {...obj1, exp_amount: 0};
                    });
                } else {
                    this.fancies = this.fancies.map((obj: any) => ({...obj, exp_amount: 0}));
                }
            } else {
                this.fancies = [];
            }
        });

        // console.log('fancy-->', this.fancies);
    }


    getLiveScore() {
        this.scoreSubscription = this.matchService.getScore(this.event_id).subscribe((res: any) => {
            if (res != null) {
                this.score = res;
                this.scoreLength = this.score.length
                if ("teams" in this.score) {
                    this.is_score = true;
                    this.last24ballsNew = this.score.last24ballsNew;
                } else {
                    this.is_score = false;
                }
                console.log('this is score-->', this.is_score);
            }
        }, (error: any) => {
            this.scoreLength = 0;
        })
    }


    getSessionBets() {
        this.sessionBetsService.getSessionBet(this.event_id).subscribe((data: any) => {
            this.session_bets = data;
            // console.log(this.session_bets);
            this.all_bets = [...this.fancy_bets, ...this.session_bets, ...this.match_bets];

        })
        
    }

    getMatchBets() {
        this.matchBetsService.getMatchBets(this.event_id).subscribe((data: any) => {
            this.match_bets = data;
                        this.all_bets = [...this.fancy_bets, ...this.session_bets, ...this.match_bets];

        });
    }

    getFancyBets() {
        this.fancyBetService.getFancyBets(this.event_id).subscribe((data: any) => {
            this.fancy_bets = data;
                        console.log(this.fancy_bets);
                                    this.all_bets = [...this.fancy_bets, ...this.session_bets, ...this.match_bets];


        });
    }

    getExposureByRunnerName() {
        this.exposureService.getExposureAmtByRunner(this.event_id).subscribe((data: any) => {
            if (data.length != 0) {
                this.exposuresPerRunner = data;
            } else {
                this.exposuresPerRunner = [];
            }
        })
    }

    getFancyExposureByRunnerName() {
        this.exposureService.getFancyExposureAmtByRunner(this.event_id).subscribe((data: any) => {
            if (data.length != 0) {
                this.fancyExposuresPerRunner = data;
            } else {
                this.fancyExposuresPerRunner = [];
            }
        })
    }

    calculateCashOut() {
        if (this.match_bets.length != 0) {

            this.cashout_submited = !this.match_bets[0].is_switched;
            let last_bet = this.match_bets[0]
            let current_market = this.market[0];
            console.log(current_market);
            console.log(last_bet.runner_name);

            this.total_profit_loss = Math.abs(last_bet.loss_amount);

            if (current_market.runner1 == last_bet.runner_name) {
                console.log('inn1');
                if (last_bet.type == 'Back') {
                    this.cashout_price = current_market.back0_price
                    if (this.cashout_price >= 1.03 && this.cashout_price <= 3.26) {
                        if (last_bet.price < current_market.back0_price) {
                            this.cash_out_profit = last_bet.exp_amount1 - ((Math.abs(last_bet.loss_amount) * current_market.back0_price) - Math.abs(last_bet.loss_amount));
                            this.status = 'loss';
                            this.total_profit_loss = Math.abs(last_bet.loss_amount) + this.cash_out_profit;
                        } else if (last_bet.price > current_market.back0_price) {
                            this.cash_out_profit = last_bet.exp_amount1 - ((Math.abs(last_bet.loss_amount) * current_market.back0_price) - Math.abs(last_bet.loss_amount));
                            this.status = 'profit';
                            this.total_profit_loss = Math.abs(last_bet.loss_amount) + this.cash_out_profit;
                            this.cash_out_profit = (this.cash_out_profit * 75) / 100;
                            this.total_profit_loss = (this.total_profit_loss * 75) / 100;
                            // console.log('b-p/l',this.cash_out_profit);
                            // console.log('b-tp/l',this.total_profit_loss);
                        } else {
                            this.cash_out_profit = 0;
                            this.total_profit_loss = Math.abs(last_bet.loss_amount);
                            this.status = 'profit';
                        }
                    }
                } else {
                    this.cashout_price = current_market.lay0_price
                    if (this.cashout_price >= 1.03 && this.cashout_price <= 3.26) {
                        if (last_bet.price < current_market.lay0_price) {
                            this.status = 'profit';
                            this.cash_out_profit = last_bet.exp_amount1 + ((Math.abs(last_bet.win_amount) * current_market.lay0_price) - Math.abs(last_bet.win_amount));
                            this.total_profit_loss = Math.abs(last_bet.loss_amount) + this.cash_out_profit;
                            this.cash_out_profit = (this.cash_out_profit * 75) / 100;
                            this.total_profit_loss = (this.total_profit_loss * 75) / 100;
                        } else if (last_bet.price > current_market.lay0_price) {
                            this.cash_out_profit = last_bet.exp_amount1 + ((Math.abs(last_bet.win_amount) * current_market.lay0_price) - Math.abs(last_bet.win_amount));
                            this.status = 'loss';
                            console.log("l-p/l", this.cash_out_profit);
                            console.log("l-tp/l", this.cash_out_profit);
                            this.total_profit_loss = Math.abs(last_bet.loss_amount) + this.cash_out_profit;
                        } else {
                            this.cash_out_profit = 0;
                            this.total_profit_loss = Math.abs(last_bet.loss_amount);
                            this.status = 'profit';
                        }
                    }
                }
            } else if (current_market.runner2 == last_bet.runner_name) {
                console.log('inn2');
                if (last_bet.type == 'Back') {
                    this.cashout_price = current_market.back1_price
                    if (this.cashout_price >= 1.03 && this.cashout_price <= 3.26) {
                        if (last_bet.price < current_market.back1_price) {
                            this.cash_out_profit = last_bet.exp_amount2 - ((Math.abs(last_bet.loss_amount) * current_market.back1_price) - Math.abs(last_bet.loss_amount));
                            this.status = 'loss';
                            this.total_profit_loss = Math.abs(last_bet.loss_amount) + this.cash_out_profit;
                        } else if (last_bet.price > current_market.back1_price) {
                            this.cash_out_profit = last_bet.exp_amount2 - ((Math.abs(last_bet.loss_amount) * current_market.back1_price) - Math.abs(last_bet.loss_amount));
                            this.status = 'profit';
                            this.total_profit_loss = Math.abs(last_bet.loss_amount) + this.cash_out_profit;
                            this.cash_out_profit = (this.cash_out_profit * 75) / 100;
                            this.total_profit_loss = (this.total_profit_loss * 75) / 100;
                            // console.log('b-p/l',this.cash_out_profit);
                            // console.log('b-tp/l',this.total_profit_loss);
                        } else {
                            this.cash_out_profit = 0;
                            this.total_profit_loss = Math.abs(last_bet.loss_amount);
                            this.status = 'profit';

                        }
                    }
                } else {
                    this.cashout_price = current_market.lay1_price
                    if (this.cashout_price >= 1.03 && this.cashout_price <= 3.26) {
                        if (last_bet.price < current_market.lay1_price) {
                            this.status = 'profit';
                            this.cash_out_profit = last_bet.exp_amount2 + ((Math.abs(last_bet.win_amount) * current_market.lay1_price) - Math.abs(last_bet.win_amount));
                            this.total_profit_loss = Math.abs(last_bet.loss_amount) + this.cash_out_profit;
                            this.cash_out_profit = (this.cash_out_profit * 75) / 100;
                            this.total_profit_loss = (this.total_profit_loss * 75) / 100;
                        } else if (last_bet.price > current_market.lay1_price) {
                            this.cash_out_profit = last_bet.exp_amount2 + ((Math.abs(last_bet.win_amount) * current_market.lay1_price) - Math.abs(last_bet.win_amount));
                            this.status = 'loss';
                            console.log("l-p/l", this.cash_out_profit);
                            console.log("l-tp/l", this.cash_out_profit);
                            this.total_profit_loss = Math.abs(last_bet.loss_amount) + this.cash_out_profit;
                        } else {
                            this.cash_out_profit = 0;
                            this.total_profit_loss = Math.abs(last_bet.loss_amount);
                            this.status = 'profit';
                        }
                    }
                }
            } else if (last_bet.runner_name.trim() == 'Draw') {
                console.log('inn3');

                if (last_bet.type == 'Back') {
                    this.cashout_price = current_market.back2_price
                    console.log('cp-->', this.cashout_price);

                    if (this.cashout_price >= 1.03 && this.cashout_price <= 3.26) {

                        if (last_bet.price < current_market.back2_price) {
                            this.cash_out_profit = last_bet.exp_amount3 - ((Math.abs(last_bet.loss_amount) * current_market.back2_price) - Math.abs(last_bet.loss_amount));
                            this.status = 'loss';
                            this.total_profit_loss = Math.abs(last_bet.loss_amount) + this.cash_out_profit;
                        } else if (last_bet.price > current_market.back2_price) {
                            this.cash_out_profit = last_bet.exp_amount3 - ((Math.abs(last_bet.loss_amount) * current_market.back2_price) - Math.abs(last_bet.loss_amount));
                            this.status = 'profit';
                            this.total_profit_loss = Math.abs(last_bet.loss_amount) + this.cash_out_profit;
                            this.cash_out_profit = (this.cash_out_profit * 75) / 100;
                            this.total_profit_loss = (this.total_profit_loss * 75) / 100;
                            // console.log('b-p/l',this.cash_out_profit);
                            // console.log('b-tp/l',this.total_profit_loss);
                        } else {
                            this.cash_out_profit = 0;
                            this.total_profit_loss = Math.abs(last_bet.loss_amount);
                            this.status = 'profit';
                        }
                    }
                } else {
                    this.cashout_price = current_market.lay2_price;
                    console.log('cp--->', this.cashout_price);
                    if (this.cashout_price >= 1.03 && this.cashout_price <= 3.26) {
                        if (last_bet.price < current_market.lay2_price) {
                            this.status = 'profit';
                            this.cash_out_profit = last_bet.exp_amount3 + ((Math.abs(last_bet.win_amount) * current_market.lay2_price) - Math.abs(last_bet.win_amount));
                            console.log("l-p/l", this.cash_out_profit);
                            this.total_profit_loss = Math.abs(last_bet.loss_amount) + this.cash_out_profit;
                            console.log("l-tp/l", this.cash_out_profit);

                            this.cash_out_profit = (this.cash_out_profit * 75) / 100;
                            this.total_profit_loss = (this.total_profit_loss * 75) / 100;
                        } else if (last_bet.price > current_market.lay2_price) {
                            this.cash_out_profit = last_bet.exp_amount3 + ((Math.abs(last_bet.win_amount) * current_market.lay2_price) - Math.abs(last_bet.win_amount));
                            this.status = 'loss';
                            console.log("l-p/l", this.cash_out_profit);
                            console.log("l-tp/l", this.cash_out_profit);
                            this.total_profit_loss = Math.abs(last_bet.loss_amount) + this.cash_out_profit;
                        } else {
                            this.cash_out_profit = 0;
                            this.total_profit_loss = Math.abs(last_bet.loss_amount);
                            this.status = 'profit';
                        }
                    }
                }
            }


            console.log(this.cash_out_profit)
            console.log(this.total_profit_loss)
            console.log(this.status);


        }
    }

    display_cashout() {
        console.log(this.cashout_price);

        if (this.cashout_price >= 1.03 && this.cashout_price < 11.01) {
            this.show_cashout_confirm = true;
        } else {
            this.cashout_errmsg = "Cash out can be done for ODDs between 1.03 and 11.01";
        }
        console.log(this.cashout_errmsg);
    }

    submit_cashout(is_confirm: boolean) {
        if (is_confirm) {
            let cashout_details = {
                user_id: localStorage.getItem('user_id'),
                event_id: this.event_id,
                runner_name: this.match_bets[0].runner_name,
                type: this.match_bets[0].type,
                new_price: this.cashout_price,
                price: this.match_bets[0].price,
                main_type: 'match_odd',
                amount: this.total_profit_loss.toFixed(2),
                status: this.status,
                loss_amount: this.match_bets[0].loss_amount,
                cashout_pl: this.cash_out_profit.toFixed(2),
                market_id: this.match_bets[0].market_id
            }
            console.log('casshh-->', cashout_details);
            this.matchBetsService.cashout(cashout_details).subscribe((res: any) => {
                this.toastr.success('cashed out successfully');
                this.getMatchBets();
            });
            this.show_cashout_confirm = false;
        } else {
            this.show_cashout_confirm = false;
        }
    }

    config: MatDialogConfig = {
        disableClose: false,
        hasBackdrop: true,
        backdropClass: 'test',
        width: '90%',
        height: '50%',
        panelClass: 'makeItMiddle', //Class Name that can be defined in styles.css as follows:
    };

    openDialog(type: any, data: any, price: any, size: any, runner_name: string, index: number = 0, min?: number, max?: number) {
        let config = {
            disableClose: true,
            autoFocus: false,
            maxHeight: '100vh',
            maxWidth: '100vh',
            width: '100vh',
            position: {top: '50px'},
            data: {
                g_type: 'cricket',
                m_type: type,
                type: data,
                user_id: localStorage.getItem('user_id'),
                event_id: this.event_id,
                runner_name: runner_name,
                value: {'price': price, 'size': size},
                market_id: this.markets.length !== 0 ? this.market[0].market_id : 0,
                index: index,
                market_name: this.market_name,
                enable_draw: this.enable_draw,
                ...(min !== undefined && max !== undefined ? {min, max} : {}),
            }
        };
        // console.log('min--.',min);
        // let firstSpan = this.btn.nativeElement;
        if (!this.isMobile) {
            this.betSlipService.setSharedData(config.data);
            this.betSlipService.callParentFunction();
        } else {
            const dialogRef = this.dialog.open(BetslipComponent, config);

            // setTimeout(() => {
            //   this.toastr.info('please select bet again');
            //   dialogRef.close();
            // }, 10000);

            dialogRef.afterClosed().subscribe(result => {
                console.log(`Dialog result: ${result}`);
            });
        }
    }

    selectTab(index: number): void {
        this.selectedTabIndex = index;
    }

    openLadder(runner: any, event_id: any) {
        const dialogRef = this.dialog.open(SessionLadder, {
            autoFocus: false,
            position: {top: '3rem'},
            maxWidth: '90vh%',
            width: '100vh',
            maxHeight: '90vh',
            data: {runner: runner, event_id: event_id}
        });
        dialogRef.afterClosed().subscribe((result: any) => {
            console.log(`Dialog result: ${result}`);
        });
    }

    toggleShowTv() {
        this.show_tv = !this.show_tv;
      }
      openbetlist(){
        const dialogRef = this.dialog.open(BetListModelComponent, {
            autoFocus: false,
            position: {top: '3rem'},
            maxWidth: '90vh%',
            width: '100vh',
            maxHeight: '100vh',
            data: {type:'cricket',Match_Odds: this.match_bets,Bookmaker: this.bookmaker_bets,Session:this.session_bets,Fancy:this.fancy_bets}
        });
        dialogRef.afterClosed().subscribe((result: any) => {
            console.log(`Dialog result: ${result}`);
        });
      }
        ngOnDestroy(): void {
        clearInterval(this.myInterval);
        this.sessionSubscription.unsubscribe();
        this.fancySubscription.unsubscribe();
        this.marketSubscription.unsubscribe();
        this.scoreSubscription.unsubscribe();
        this.bookmakerSubscription.unsubscribe();
        }

    checkIsMobile() {
        this.isMobile = window.innerWidth <= 768;
    }


getVendorList() {
        this.liveCasinoService.getProvidersRequestsIgtech().subscribe((res: any) => {
        if (res.success) {
            this.vendors = Object.entries(res.categories).map(([providerCode, providerData]:any) => ({
                providerCode,providerName: providerData.provider_name
            }));
            this.vendors.unshift({ providerCode: "All", providerName: "All" });
            this.allCategories = res.categories;
            const allCategories = Object.values(res.categories).flatMap((providerData:any) => providerData.categories);
            this.categories = Array.from(new Set(allCategories));
            this.onVendorChange("All");
        }
        });
    }
    onVendorChange(selectedVendor: string, searchKeyword: any=null) {
        this.activeVendor = selectedVendor;
        this.searchKeyword = searchKeyword;
        if (selectedVendor === "All") {
            const allCategories = Object.values(this.allCategories).flatMap((providerData:any) => providerData.categories);
            this.categories = Array.from(new Set(allCategories));
        } else {
            this.categories = this.allCategories[selectedVendor].categories;
        }
        this.onSelectCategory("Popular");
        //this.onSelectCategory(this.categories[0]);
    }

    onSelectCategory(category:string) {
        this.activeCategory = category;
        if (category === 'Popular') {
            this.filtered_gameList = this.popular_games;
            this.isloading = false;
            this.totalPages = 1;
            return;
        }
        if (this.activeCategory) this.getGameList(this.activeVendor,this.activeCategory, null, this.searchKeyword);
    }

    getGameList(provider: string,category:string, page:any=null, searchKeyword:any) {
        this.gameurl = "";
        this.activeVendor = provider;

        this.isloading = true;
        this.liveCasinoService.getGamesByCategoryRequestsIgtech(provider,category,page,searchKeyword).subscribe((res: any) => {
            this.gameList = res.games;
            this.filtered_gameList = this.gameList;
            this.isloading = false;
            this.totalPages = res.total_pages;
        });
    }
    

    changePage(page: number) {
        if (page > 0 && page <= this.totalPages) {
            this.currentPage = page;
            this.isloading = true;
            this.getGameList(this.activeVendor,this.activeCategory,this.currentPage, this.searchKeyword);
        }
    }
  
    getPaginationRange(): any[] {
        const pages = [];
        pages.push(1);
        if (this.currentPage > 3) {
          pages.push('...');
        }
        for (let i = Math.max(2, this.currentPage - 1); i <= Math.min(this.totalPages - 1, this.currentPage + 1); i++) {
          pages.push(i);
        }
        if (this.currentPage < this.totalPages - 2) {
          pages.push('...');
        }
        if (this.totalPages > 1) {
          pages.push(this.totalPages);
        }
        return pages;
    }

    capitalizeFirstLetter(val:string) {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }

    onSearch(event: Event) {
        const input = event.target as HTMLInputElement;
        const value = input.value;
    
        clearTimeout(this.typingTimer);
    
        // Set a new timer
        this.typingTimer = setTimeout(() => {
          if (value.trim() !== '') {
            this.onVendorChange("All",value);
          } else {
            this.onVendorChange("All");
          }
        }, this.doneTypingInterval);
    }

    onSearch_local(event: Event) {
        const input = event.target as HTMLInputElement;
        const value = input.value;
    
        clearTimeout(this.typingTimer);
    
        // Set a new timer
        this.typingTimer = setTimeout(() => {
          if (value.trim() !== '') {
            this.filter_games(value);
          } else {
            this.activeCategory = "All";
            //this.activeCategory = this.categories[0];
            this.filtered_gameList = this.gameList;
          }
        }, this.doneTypingInterval);
    }

    filter_games(label: string) {
        this.activeCategory = 'search';
        const normalizedSearchTerm = label.toLowerCase().replace(/\s+/g, '');
        this.filtered_gameList = this.gameList.filter((game:any) => {
            const normalizedGameName = game.game_name.toLowerCase().replace(/\s+/g, '');
            return normalizedGameName.includes(normalizedSearchTerm);
        });
    }

    openCasino(provider: any) {
        this.router.navigate(['/dashboard/casino', provider]);
    }

    getGameUrl(gameid: any) {
        const selectedgame= this.selectedGame;

        const data ={
            gameId: gameid,
            provider: this.selectedGame,
            userId: this.user_id,
            balance: this.balance,
            exposure: this.exposure
        }
        // console.log(data)

        this.liveCasinoService.getGamesUrlByidRequests(data).subscribe((res: any) => {

            this.gameurl = this.sanitizer.bypassSecurityTrustResourceUrl(res.launch_url);
            this.router.navigate(['/casino-detail/', gameid, selectedgame])
        });
    }

    openNewGameTab(gameid: any, provider:any) {
        this.router.navigate(['/casino-detail-igtech/',gameid,provider])
    }

    openLobby() {
        const url = '/casino-detail-igtech/true/lobby';
        window.open(url, '_blank');
    }      

    activateAccount() {
        this.liveCasinoService.activateAccountRequests().subscribe((res: any) => {
            this.is_active=true;
            this.getVendorList();
            alert('Account Activated');
        });
    }

    setSelectedGame(gameName: string) {
        this.selectedGame = gameName;
    }

    getExposureDetails() {
    this.exposureService.getExposure().subscribe((data: any) => {
        this.exposure = data[0].exp_amount;
    }, (error) => {
        this.exposure = [];
    })
    }

    onImageError(event: any) {
        event.target.src = './assets/images/no_images.png';
    }



}



